export default {
      id: "fr-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#fr",
      toString: function () {
        return this.url;
      }
    }